<div class="breadcrumbs">
  <span class="title">Gestione Emergenze
    <mat-icon style="vertical-align: middle;">
      keyboard_arrow_right
    </mat-icon>
    Gestione segnalazioni
    <mat-icon style="vertical-align: middle;">
      keyboard_arrow_right
    </mat-icon>
    <span *ngIf="isModifica && !isDettaglioStoricoSegnalazione">Compilazione segnalazione</span>
    <span *ngIf="!isModifica && !isDettaglioStoricoSegnalazione">Dettaglio segnalazione 2</span>
    <span *ngIf="isDettaglioStoricoSegnalazione">Dettaglio segnalazione storica</span>
  </span>
</div>
<hr>
<div class="titolo flex-display">
  <div class="flex-display">
    <button mat-stroked-button class="pers" (click)="onNavigate()">
      <mat-icon style="vertical-align: middle;">keyboard_arrow_left</mat-icon>
    </button>
    <div class="denom">
      <span *ngIf="isModifica" class="h1 upp">Compilazione segnalazione</span>
      <span *ngIf="!isModifica" class="h1 upp">Dettaglio segnalazione</span>
    </div>
  </div>

  <div class="flex-row">
    <button *ngIf="isRifiutabile() && !isDettaglioStoricoSegnalazione && recuperatoFormMorfeo" mat-stroked-button color='basic' class="pers2 mleft" (click)="changeStatoSegnalazione('rifiutare')">
      RIFIUTA
    </button>
    <button *ngIf="isRiapribileSegnalazione() && !isDettaglioStoricoSegnalazione && recuperatoFormMorfeo" mat-stroked-button color='basic' class="pers2 mleft" (click)="changeStatoSegnalazione('correzione')">
      RIAPRI SEGNALAZIONE
    </button>
    <button *ngIf="isNonRicevuta() && !isDettaglioStoricoSegnalazione && recuperatoFormMorfeo" mat-stroked-button color='basic' class="pers2 mleft" (click)="changeStatoSegnalazione('nonricezione')">
      NON RICEVUTA
    </button>
    <button *ngIf="isRicevibile() && !isDettaglioStoricoSegnalazione && recuperatoFormMorfeo" mat-stroked-button color='basic' class="pers2 mleft" (click)="changeStatoSegnalazione('validare')">
      RICEVI SEGNALAZIONE
    </button>
    <button *ngIf="isConfermabile() && !isDettaglioStoricoSegnalazione && recuperatoFormMorfeo" mat-stroked-button color='basic' class="pers2 mleft" (click)="changeStatoSegnalazione('confermare')">
      CONFERMA
    </button>
    <button *ngIf="isConfermabileSegnalazione() && !isDettaglioStoricoSegnalazione && isModifica && recuperatoFormMorfeo" mat-stroked-button color='basic' class="pers2 mleft" (click)="changeStatoSegnalazioneCompletare()">
      CONFERMA SEGNALAZIONE
    </button>
    <button *ngIf="isEsportabile() && !isDettaglioStoricoSegnalazione && recuperatoFormMorfeo" mat-stroked-button color='basic' class="pers2 mleft" (click)="onEsportaSegnalazione()">
      ESPORTA SEGNALAZIONE
    </button>
    <button *ngIf="!isDettaglioStoricoSegnalazione && !isNewSegnalazione" mat-stroked-button color='basic' class="pers2 mleft" (click)="onVisualizzaStorico()">
      VISUALIZZA STORICO
    </button>
    <button *ngIf="showBtnAnomalie && !isDettaglioStoricoSegnalazione" mat-stroked-button  color='basic' class="pers2 mleft" (click)="openDialogAnomalie()">
      ANOMALIE
    </button>
    <button *ngIf="canUpdate && !isDettaglioStoricoSegnalazione && isModifica" mat-flat-button color='accent' class="pers3 mleft" (click)="onSaveEvent()">
      SALVA MODIFICHE
    </button>
    <p class="persP" *ngIf="isDettaglioStoricoSegnalazione"> Versione data: <br>{{this.datePipe.transform(dataStoricizzazione, 'dd/MM/yyyy HH:mm:ss')}}</p>
  </div>

</div>

<div class="pers titles">
  <span class="title"> SELEZIONE TIPO RICHIESTA </span>
</div>

<div class="compilazione">
<div class="form-flex-row" [formGroup]="form">
    <input hidden [formControlName]="'idDatiRaccolti'">
</div>

<div class="form-flex-row mbt13" [formGroup]="form">
  <mat-form-field class="mat-input-wrapper" color="accent" appearance="fill">
    <mat-label class="big-blue">Descrizione segnalazione*</mat-label>
    <input matInput [formControlName]="'descrizione'">
  </mat-form-field>
  <mat-error *ngIf="this.form.controls.descrizione.errors && this.form.controls.descrizione.touched">
    <mat-error *ngIf="this.form.controls.descrizione.errors.required">Campo obbligatorio
    </mat-error>
    <mat-error *ngIf="this.form.controls.descrizione.errors.maxlength">Il numero massimo di caratteri consentiti è 100
    </mat-error>
  </mat-error>
</div>

<div class="form-flex-row mbt13" [formGroup]="form">
  <mat-form-field class="mat-input-wrapper" color="accent" appearance="fill">
    <mat-label class="big-blue">Selezionare il template da utilizzare per questa segnalazione</mat-label>
    <mat-select (valueChange)="caricaFormPerSegnalazione($event)" [formControlName]="'idTemplateSelect'">
      <mat-option *ngFor="let templateItem of templateList" [value]="templateItem.idTemplate">
        {{templateItem.descrizione}}</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-error *ngIf="this.form.controls.idTemplateSelect.errors && this.form.controls.idTemplateSelect.touched">
    <mat-error *ngIf="this.form.controls.idTemplateSelect.errors.required">Campo obbligatorio
    </mat-error>
  </mat-error>
</div>


<ng-container *ngIf="segnalazioneData?.numProtocolloEnteAttuatore || segnalazioneData?.numProtocolloRVE">
  <div class="form-flex-row mbt13">
    <mat-form-field class="mat-input-wrapper" color="accent" appearance="fill">
      <mat-label class="big-blue">Protocollo Ente Attuatore</mat-label>
      <input
        matInput
        [value]= "(segnalazioneData.numProtocolloEnteAttuatore && segnalazioneData.dataProtocolloEnteAttuatore) ? (segnalazioneData.numProtocolloEnteAttuatore + ' del ' + (segnalazioneData.dataProtocolloEnteAttuatore | date:'dd/MM/yyyy')) : '-'"
        [disabled]="true">
    </mat-form-field>
  </div>
  <div class="form-flex-row mbt13">
    <mat-form-field class="mat-input-wrapper" color="accent" appearance="fill">
      <mat-label class="big-blue">Protocollo Regione del Veneto</mat-label>
      <input
        matInput
        [value]="(segnalazioneData.numProtocolloRVE && segnalazioneData.dataProtocolloRVE) ? (segnalazioneData.numProtocolloRVE + ' del ' + (segnalazioneData.dataProtocolloRVE | date:'dd/MM/yyyy')) : '-'"
        [disabled]="true">
    </mat-form-field>
  </div>
</ng-container>


<div class="form-flex-row mbt13" *ngIf="isRevisionata">
  <mat-form-field class="mat-input-wrapper" color="accent" appearance="fill" >
    <mat-label class="big">Segnalazione Rettificata:</mat-label>
    <input matInput [value]="isRevisionata?'Sì':'No'" [disabled]="true">
  </mat-form-field>
</div>

</div>

<div class="pers titles" *ngIf="this.form.controls.idTemplateSelect.value">
  <span class="title"> DATI MODULO </span>
</div>

<form class="flex-form compilazione">
<mrf-form [form]="formJson" [config]="formSubmit"></mrf-form>
</form>

